const type = 'SET_PAYMENT_EMAIL_SENDING';

const setPaymentEmailSending = (data) => ({
  data,
  type,
});

export default setPaymentEmailSending;
